export default __webpack_public_path__ + "static/media/section-videos.ca45e4f3.png";